import { Injectable, inject } from '@angular/core';
import { FullSpectacleData, SmartlifeQuery } from '@oe-backend/types';
import { ResponseObjectApiInterface } from 'src/app/types/interfaces/api-responses/response-object.api.interface';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({ providedIn: 'root' })
export class SmartlifeService extends BaseApiService {
	private http = inject(HttpClient);

	fetchVrxValues(query: SmartlifeQuery) {
		return this.http
			.post<ResponseObjectApiInterface<FullSpectacleData>>(`${this.apiBaseUrl}/smartlife`, query)
			.pipe(
				map((response: ResponseObjectApiInterface<FullSpectacleData>) => {
					return response.data;
				}),
			);
	}
}
